
import { useNavigate, useParams } from "react-router-dom";
import { Section } from "../components/styled/Containers.style";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import { Vspace } from '../components/styled/Separators.style'
import { composeUrl } from "../utils/utils";
import { PATHS } from "../routes/CaiExperienceRouter";
import PageContainerCmp from "./PageContainerCmp";
import FotoPatente from "../components/foto-patente/FotoPatente";
import { selectCommunicationData } from "../store";
import { useAppSelector } from "../store/hooks";

/* istanbul ignore next */
const Trct_FotoPatentePage = () => {
    let navigate = useNavigate();
    let { token } = useParams();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const nextBtnDisabled = !communication?.fotoPatente || communication.fotoPatente.length < 2;

    const goToNextStepHandler = () => {
        navigate(composeUrl(token, PATHS.CAI_FILLING_CONDUCENTE))
    }

    return (
        <>
            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.TRCT_FOTO_PATENTE}
                nextDisabled={nextBtnDisabled}
            >
                <>
                    <Section>
                        <PageTitle>Foto della tua patente</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered>Scatta una foto della patente del conducente del veicolo – sia fronte, che retro. Non hai la patente? Scatta una foto del tuo documento di identità.</TextDefault>
                        <Vspace></Vspace>
                        <TextDefault centered>Assicurati che il documento risulti leggibile e ben illuminato. Non è possibile fotografare fotocopie.</TextDefault>
                    </Section>

                    <FotoPatente
                        onTotFotoIsRiched={goToNextStepHandler} />
                </>
            </PageContainerCmp>
        </>

    )
}

export default Trct_FotoPatentePage